import React, { Component } from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import ListView from './components/list-view'
import FilterBar from './components/filter-bar'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner, TextInput } from 'elements'
import { allProfilesInfoSelector, currentClientStatusSelector } from 'redux/selectors'
import { jsonToQueryString, parseQueryString } from 'utils/helpers'
import { listAllProfiles } from 'redux/modules/model/operator';
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs'

const predicate = (criteria) => (item) => {
    if (criteria.search) {
        const ucSearch = criteria.search.toUpperCase()
        return item.clientId.toUpperCase().includes(ucSearch) ||
            item.displayName.toUpperCase().includes(ucSearch)
    }
    if (!criteria.showAll) {
        return item.active
    }
    return true
}

class ProfileList extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        listAllProfiles: PropTypes.func.isRequired,
        logUserTab: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        operatorListStatus: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props)
        this.state = {
            search: null
        }
    }

    componentDidMount() {
        const { clientId, logUserTab, listAllProfiles } = this.props
        listAllProfiles({ clientId })
        const tab = "Profile"
        logUserTab({ clientId, tab })
    }

    setURLHref = (params) => {
        const { history } = this.props
        history.push({
            location: ROUTES.DIRECTORY,
            search: jsonToQueryString(params)
        })
    };

    handleViewModeChange = (view) => {
        const { location } = this.props
        const params = {
            ...parseQueryString(location.search),
            view
        }
        this.setURLHref(params)
    };

    handleSearchChange = (e) => {
        this.setState({
            search: e.target.value
        })
    }

    render() {
        const { operatorListStatus, location, allProfilesList } = this.props
        const params = parseQueryString(location.search)
        const { view = 'list' } = params
        const criteria = {
            ...params,
            search: this.state.search || params.search
        }
        // const filteredClients = fp.filter(predicate(criteria))(clientList)
        const filteredProfiles = Object.values(allProfilesList)

        return (
            <div>
                <FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
                {API_PENDING === operatorListStatus && <Spinner />}
                {API_SUCCESS === operatorListStatus && <ListView profiles={filteredProfiles} />}
                {API_FAIL === operatorListStatus && <h2>Failed to load profiles</h2>}
            </div>
        )
    }
}

export const selector = createStructuredSelector({
    operatorListStatus: currentClientStatusSelector,
    allProfilesList: allProfilesInfoSelector
})

export const actions = {
    listAllProfiles,
    logUserTab
}

export default compose(
    withRouter,
    withClientId,
    connect(selector, actions),
)(ProfileList)



// WEBPACK FOOTER //
// ./src/pages/profile/profile-list/index.js